<script lang="ts">
  import { Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle,  Label, Row } from "sveltestrap";
  import { Action, href } from "../../../../utils/Constant/Constant";
  import data from "../../../../Data/Email/Email.json"
  import InboxData from "./InboxData.svelte";

</script>
<Col xl="9" md="12" class="xl-70 box-col-8">
    <div class="email-right-aside">
      <div class="card email-body">
        <div class="email-profile">
          <div>
            <div class="pe-0 b-r-light"></div>
            <div class="email-top">
              <Row>
                <Col xs="12">
                  <div class="media">
                    <Label class="email-chek d-block" for="chk-ani">
                      <input class="checkbox_animated" id="chk-ani" type="checkbox" checked >
                    </Label>
                    <div class="media-body">   
                      <Dropdown class="icon-dropdown">
                        <DropdownToggle class="btn-primary" caret>{Action}</DropdownToggle>
                        <DropdownMenu>
                          {#each data.dropdownbtndata as btnItem}
                              <DropdownItem href={href}>{btnItem}</DropdownItem>
                          {/each}
                        </DropdownMenu>
                      </Dropdown>        
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <InboxData />
          </div>
        </div>
      </div>
    </div>
</Col>
